import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("verifying");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("invalid"); return; }
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => setState("verified"))
      .catch(() => setState("invalid"));
  }, [params]);

  return (
    <div data-testid="verify-email-page" className="min-h-screen grid place-items-center bg-black px-4">
      <div className="card-surface p-8 max-w-sm text-center space-y-3">
        {state === "verifying" && <p className="text-zinc-400 text-sm">Verifying your email…</p>}
        {state === "verified" && (
          <>
            <div className="text-4xl">✅</div>
            <h1 className="font-display text-2xl">Email verified!</h1>
            <p className="text-xs text-zinc-400">You're officially part of the Panda Pack.</p>
            <Link to="/feed" data-testid="verify-email-continue" className="inline-block bg-rose-600 hover:bg-rose-500 text-white text-xs uppercase tracking-widest px-6 py-3 transition-colors">
              Enter the Vault
            </Link>
          </>
        )}
        {state === "invalid" && (
          <>
            <div className="text-4xl">⚠️</div>
            <h1 className="font-display text-2xl">Link expired</h1>
            <p className="text-xs text-zinc-400">This verification link is invalid or has expired.</p>
          </>
        )}
      </div>
    </div>
  );
}
